import * as ActionCreators from '../actionCreators/firepanel';
const defaultState = {
  firePanelStatus: false,
  firePanelList: [],
};

const FirepanelReducer = (state = defaultState, action) => {
  switch (action.type) {
    case ActionCreators.setFirePanelStatus().type:
      return {
        ...state,
        firePanelStatus: action.payload,
      };
    case ActionCreators.setFirePanelList().type:
      return {
        ...state,
        firePanelList: action?.payload?.length > 0 ? action?.payload : [],
      };
    default:
      return state;
  }
};

export default FirepanelReducer;
